import { useMemo } from "react";
import { _Product_liquid, _Variant_liquid } from "./_types";
import { ProductItemImageCheckbox } from "./product-item-image-checkbox";

interface Props {
  productList: _Product_liquid[];
  renderingStrategy?: "per_product" | "per_variant";
  displayPrice?: boolean;
  selectedProduct?: _Product_liquid;
  selectedVariant?: _Variant_liquid;
  gridColumnsDesktop?: string;
  gridColumnsMobile?: string;
  shouldShowProductTitle?: boolean;
  onProductSelect: (
    product: _Product_liquid,
    variant: _Variant_liquid,
    isChecked?: boolean
  ) => void;
}

const DESKTOP_COLS_CLASSES = {
  "3": "md:grid-cols-3",
  "4": "md:grid-cols-4",
  "5": "md:grid-cols-5",
  "6": "md:grid-cols-6",
};
const MOBILE_COLS_CLASSES = {
  "1": "grid-cols-1",
  "2": "grid-cols-2",
  "3": "grid-cols-3",
  "4": "grid-cols-4",
};

const getGridClasses = (desktopCols?: string, mobileCols?: string) => {
  const desktop = DESKTOP_COLS_CLASSES[desktopCols || "5"] || "md:grid-cols-5";
  const mobile = MOBILE_COLS_CLASSES[mobileCols || "2"] || "grid-cols-2";
  return `grid ${desktop} ${mobile} gap-4`;
};

export const ProductGroupCheckboxImageCard = ({
  productList,
  renderingStrategy,
  displayPrice,
  selectedProduct,
  selectedVariant,
  gridColumnsDesktop,
  gridColumnsMobile,
  shouldShowProductTitle,
  onProductSelect,
}: Props) => {
  const productsToShow = useMemo(() => {
    if (renderingStrategy === "per_variant") {
      return [
        {
          id: 0,
          variants: productList.flatMap((p) =>
            p.variants.map((v) => ({
              ...v,
              _parentProduct: p,
            }))
          ),
        },
      ];
    } else {
      return productList;
    }
  }, [productList, renderingStrategy]);

  return (
    <div className={"flex max-h-[500px] flex-col gap-8 overflow-y-auto md:max-h-none"}>
      {productsToShow.map((product, idx) => {
        return (
          <div key={product.id + idx} className={"flex flex-col gap-2"}>
            {shouldShowProductTitle && (
              <h4 className={"sticky left-0 right-0 top-0 z-10 bg-white py-2 text-sm"}>
                {product.title}
              </h4>
            )}
            <div className={getGridClasses(gridColumnsDesktop, gridColumnsMobile)}>
              {product.variants.map((variant) => {
                const parentProduct =
                  renderingStrategy === "per_variant" ? (variant as any)._parentProduct : product;
                const isChecked =
                  selectedProduct?.id === parentProduct.id && selectedVariant?.id === variant.id;
                return (
                  <ProductItemImageCheckbox
                    key={variant.id}
                    product={parentProduct}
                    variant={variant}
                    displayPrice={displayPrice}
                    gridColumnsDesktop={gridColumnsDesktop}
                    checked={isChecked}
                    showProductTitle={renderingStrategy === "per_variant"}
                    onClick={() => {
                      onProductSelect(parentProduct, variant, isChecked);
                    }}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
